import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class NotStartedSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g id="illustration_thinking" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            d="M88.1453859,81.0937538 C89.3202245,82.1488052 90.0321694,83.701258 89.9610461,85.4019659 C89.8332993,88.4220657 87.2811414,90.768718 84.2596531,90.6409712 C82.3898639,90.6409712 80.4258568,89.8545404 79.3587266,88.1706378 C75.0424703,90.042976 70.0687835,90.7826668 65.3171073,90.7826668 C55.1501322,90.7826668 40.1232265,86.6461715 39.0804242,72.1233099 C37.9223721,56.0050026 49.3973628,47.3348862 65.3171073,47.3348862 C81.2382403,47.3348862 91.4260436,54.5331379 91.4260436,69.0587765 C91.4260436,74.0604681 90.1970313,78.0116003 88.1453859,81.0937538 Z M94.8962363,87.8802529 L94.8962363,87.8733101 C95.0100975,87.8677559 95.1239588,87.8677559 95.23782,87.8733101 C97.4817194,87.9663431 99.2229632,89.8631046 99.1285417,92.1056155 C99.0341202,94.3481264 97.1401357,96.0907587 94.8962363,95.9963371 C92.8522883,95.9963371 90.6583767,94.7299781 90.6583767,91.9389893 C90.8194487,89.6992555 92.6509483,87.9441262 94.8962363,87.8802529 Z"
            id="Combined-Shape"
            className={css(styles.action)}
          />
          <polygon id="Fill-3" className={css(styles.grey)} points="53 78 74 78 74 65 53 65" />
          <path
            d="M50.0618018,65 L57.9416504,61 L78.9416504,61 L70.9416504,65 L71,65 L71,67 L50,67 L50,65 L50.0618018,65 Z"
            id="Combined-Shape"
            className={css(styles.actionAccent)}
          />
          <path
            d="M71,65 L79,61 L79,78 L74,78 L74,65.6156616 L71,67 L71,65 Z M56,74 L56,70 L59,70 L59,74 L56,74 Z M62,74 L62,70 L65,70 L65,74 L62,74 Z M68,74 L68,70 L71,70 L71,74 L68,74 Z"
            id="Combined-Shape"
            fill="#FFFFFF"
          />
          <path
            d="M20.3844059,52.8748965 C19.4302826,54.2632494 17.8047199,55.144767 15.9978,55.0684 C13.4538,55.0684 10.7228,53.4914 10.7228,50.0164 C10.8676853,48.0067478 12.0927869,46.3109247 13.8119684,45.4907228 C12.5644525,43.0954505 11.7515307,40.3166202 11.521,37.1052 C10.162,18.1802 23.633,7.9992 42.325,7.9992 C61.017,7.9992 72.98,16.4492 72.98,33.5062 C72.98,53.1822 56.778,59.0122 42.325,59.0122 C35.4977652,59.0122 26.804984,57.4239999 20.3844059,52.8748965 Z M4.9168,53.1216 L4.9168,53.1156 C5.0218,53.1106 5.1278,53.1106 5.2328,53.1156 C7.3058,53.2026 8.9158,54.9536 8.8288,57.0266 C8.7418,59.1006 6.9898,60.7106 4.9168,60.6226 C3.0278,60.6226 0.9998,59.4526 0.9998,56.8726 C1.1488,54.8026 2.8418,53.1816 4.9168,53.1216 Z"
            id="Combined-Shape"
            className={css(styles.grey)}
          />
          <polygon id="Fill-16" className={css(styles.action)} points="51 22 33 22 26 30.9959717 44 30.9959717" />
          <polygon id="Fill-17" fill="#FFFFFF" points="58 31 51 22 43.9985352 31 43.9985352 45 58 45" />
          <path
            d="M52.9865832,39.1674047 L53,39.1674047 L53,45 L49,45 L49,39.1674047 L49.0143113,39.1674047 C49,38.1292847 49.9749553,37.2182617 51,37.2182617 C52.0250447,37.2182617 53,38.1292847 52.9865832,39.1674047 Z M26,45 L26,31 L44,31 L44,45 L26,45 Z"
            id="Combined-Shape"
            className={css(styles.actionAccent)}
          />
          <path
            d="M30,40 L30,36 L33,36 L33,40 L30,40 Z M37,40 L37,36 L40,36 L40,40 L37,40 Z"
            id="Combined-Shape"
            fill="#FFFFFF"
          />
        </g>
      </svg>
    );
  }
}
